@if (notificationsList$ | async; as list) {
  @if (isLoading$) {
    <app-pagination-container
      [class]="isModalMode ? '' : 'notifications'"
      [isLoading$]="isLoading$"
      [paginationData]="list"
      [isFiltersPagination]="isModalMode"
      [noDataText]="'У вас нет новых уведомлений'"
      [isAllLoaded]="isAllLoaded$ | async"
      (emitScrolling)="getNotificationsList()"
    >
      @for (notify of list; track notify) {
        <div>
          <app-notification-card
            [notify]="notify"
            [isModalMode]="isModalMode"
            [notificationCurrentPageType]="pageType"
          ></app-notification-card>
        </div>
      }
    </app-pagination-container>
  }
}
